import { gql } from '@apollo/client';

export const GetPreviewOfferContract = gql`
  query GetPreviewOfferContract($legalCid: String!, $accommodationObjectCid: String!, $contractType: ContractType!) {
    getPreviewOfferContract(
      legalCid: $legalCid
      accommodationObjectCid: $accommodationObjectCid
      contractType: $contractType
    ) @rest(path: "/offer-contracts/preview?{args}", method: "GET") {
      data
      errors {
        ...Error
      }
    }
  }
`;

export const GetAccountOfferContract = gql`
  query GetAccountOfferContract($contractNumber: Int!) {
    getAccountOfferContract(contractNumber: $contractNumber)
      @rest(path: "/offer-contracts/offer?{args}", method: "GET") {
      data
      errors {
        ...Error
      }
    }
  }
`;
